import { EditContractPeriod } from '../editContract/editContractPeriod';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import { FormatDate } from '../../../utils/formatDate';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import Iconify from '../../Iconify';
import '../../../css/contracts/contractPeriod.css';

const ContractPeriod = ({ currentPeriod, setCurrentPeriod }) => {

    const contractDetailsData = useSelector((state) => state.ContractDetailsData);
    const contractDates = contractDetailsData?.contract_date || [];
    const hasContractUpdatePermission = useHasPermission('contract_update');

    const [openEditPeriod, setOpenEditPeriod] = useState(false);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    const now = new Date();
    const workingPeriodIndex = contractDates.findIndex(period => {
        const startDate = new Date(period.start_date);
        const endDate = period.end_date ? new Date(period.end_date) : null;
        return now >= startDate && (!endDate || now <= endDate);
    });

    const handleDisplayNextPeriod = () => {
        if (currentPeriod > 0) {
            setCurrentPeriod(currentPeriod - 1);
        }
    };

    const handleDisplayPreviousPeriod = () => {
        if (currentPeriod < contractDates.length - 1) {
            setCurrentPeriod(currentPeriod + 1);
        }
    };

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleMenuItemClick = (index) => {
        setCurrentPeriod(index);
        handleMenuClose();
    };

    return (
        <Box className='contractPeriod_period_actions_box'>
            <Box className='contractPeriod_main_box'>

                {workingPeriodIndex !== -1 &&
                    <Typography className='contractPeriod_enCours' onClick={() => setCurrentPeriod(workingPeriodIndex)}>En cours</Typography>
                }
                {contractDates.length > 1 && (
                    <Box className='contractPeriod_arrow_icon_box'>
                        {currentPeriod !== contractDates.length - 1 &&
                            <Iconify
                                icon="ic:round-arrow-back-ios"
                                className={`contractPeriod_arrow_icon`}
                                onClick={handleDisplayPreviousPeriod}
                            />
                        }
                        {currentPeriod !== 0 &&
                            <Iconify
                                icon="ic:round-arrow-forward-ios"
                                className={`contractPeriod_arrow_icon`}
                                onClick={handleDisplayNextPeriod}
                            />
                        }
                    </Box>
                )}

                <Box className='contractPeriod_arrow_icon_box'>
                    <Typography className='contractPeriod_display_date'>
                        {FormatDate(contractDates[currentPeriod]?.start_date)} - {contractDates[currentPeriod]?.end_date ? FormatDate(contractDates[currentPeriod]?.end_date) : 'Ouvert'}
                    </Typography>
                    {contractDates.length > 1 && (
                        <Iconify
                            icon="ep:arrow-down"
                            className='contractPeriod_arrow_icon'
                            onClick={handleMenuOpen}
                        />
                    )}
                </Box>

                <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    {contractDates.map((date, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => handleMenuItemClick(index)}
                        >
                            {FormatDate(date.start_date)} - {date.end_date ? FormatDate(date.end_date) : 'Ouvert'}
                        </MenuItem>
                    ))}
                </Menu>

            </Box>

            {hasContractUpdatePermission &&
                <Box className='contractPeriod_enCours' onClick={() => setOpenEditPeriod(true)}>
                    <Iconify icon='ep:setting' />
                    <Typography className='contractPeriod_add_period_btn'>Gérer les périodes</Typography>
                </Box>
            }

            {openEditPeriod &&
                <EditContractPeriod
                    currentPeriod={currentPeriod}
                    openEditPeriod={openEditPeriod}
                    setOpenEditPeriod={setOpenEditPeriod}
                />
            }
        </Box>
    );
};

export default ContractPeriod;